import { inject, Injectable } from "@angular/core";
import { WilayaService } from "admin-common";
import { AdressGlobalService } from "./adressGlobal.service";

/**
 * The admin-common WilayaService with the wilaya names in the current language: provided in place of the lib one
 * where a lib component lists the wilayas itself (lib-adresse-popup). The values (ALGER…) are unchanged.
 */
@Injectable()
export class LocalizedWilayaService extends WilayaService {
  private adressGlobalService = inject(AdressGlobalService);

  override getWilayasItems() {
    return super.getWilayasItems().map((wilaya) => ({
      ...wilaya,
      name: this.adressGlobalService.getWilayaLabel(wilaya.value),
    }));
  }
}
